<template>
  <div class="submenu-container">
    <template v-for="nav in navList">
      <!-- 子菜单 -->
      <ul
        v-if="nav.subNavList.length >= 1 && !nav.isGroupTitle"
        :key="nav.path"
        :index="nav.path"
        :class="['submenu', isOpened(nav.path) ? 'is-opened' : '', level > 1 ? 'more-level' : '']"
      >
        <div
          class="submenu-title-container"
          @click="onClickSubMenu(nav.path)"
        >
          <ChevronRightIcon />
          <span class="submenu-title">{{ nav.title }}</span>
        </div>
        <SubMenu
          v-show="isOpened(nav.path)"
          :nav-list="nav.subNavList"
          :opened-menus="openedMenus"
          :default-path="path"
          :level="level + 1"
          @select="onSelect"
          @clickSubMenu="onClickSubMenu"
        />
      </ul>
      <!-- 分组标题  -->
      <li
        v-else-if="nav.isGroupTitle"
        :key="nav.path"
        :class="['menu-group-title', level > 1 ? 'more-level' : '']"
        v-html="nav.title"
      />
      <!-- 菜单项 -->
      <li
        v-else-if="!isExternalLink(nav.path)"
        :key="nav.path"
        :class="['menu-item', nav.path === path ? 'is-actived' : '', level > 1 ? 'more-level' : '']"
        :index="nav.path"
        @click="onSelect(nav.path)"
        v-html="nav.title"
      />
      <a
        v-else
        :key="nav.path"
        style="color: init"
        target="_blank"
        :href="nav.path"
        :class="['menu-item', level > 1 ? 'more-level' : '']"
        v-html="nav.title"
      />
    </template>
  </div>
</template>
<script>
import { ChevronRightIcon } from 'tdesign-icons-vue';

export default {
  name: 'SubMenu',
  components: {
    ChevronRightIcon
  },
  props: {
    navList: {
      default() {
        return [];
      },
      type: Array
    },
    openedMenus: {
      default() {
        return [];
      },
      type: Array
    },
    defaultPath: {
      type: String,
      default: ''
    },
    level: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      path: this.defaultPath,
    };
  },
  watch: {
    defaultPath(newPath) {
      this.path = newPath;
    }
  },
  methods: {
    onClickSubMenu(path) {
      this.$emit('clickSubMenu', path);
    },
    isExternalLink(link) {
      if (typeof link !== 'string') {
        return false;
      }
      if (link.indexOf('https') === 0 || link.indexOf('http') === 0) {
        return true;
      }
      return false;
    },
    isOpened(path) {
      return this.openedMenus.includes(path);
    },
    onSelect(path) {
      this.path = path;
      this.$emit('select', path);
    }
  }
};
</script>
<style>
</style>
<style lang="less" scoped>
.submenu-container {
  color: rgba(0, 0, 0, 0.90);
  .submenu {
    padding: 4px 0;
    cursor: pointer;
    &.more-level {
      margin-left: 20px;
      padding-left: 0;
      .submenu-title {
        font-size: 14px;
        line-height: 22px;
      }
      .submenu-title-container {
        padding: 5px 0;
      }
    }
    .submenu-title-container {
      display: flex;
      align-items: center;
      border-radius: 6px;
      padding: 8px 0;
      &:hover {
        background-color: #F7F9FD;
      }
    }
    .t-icon {
      color: #0F182980;
      margin-left: 2px;
    }
    .submenu-title {
      font-size: 16px;
      line-height: 24px;
      margin-left: 4px;
    }
    &.is-opened {
      > .submenu-title-container {
        .t-icon {
          transform: rotate(90deg);
        }
      }
      .submenu-container {
        position: relative;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          left: 8px;
          width: 1px;
          background-color: rgba(206, 213, 222, 0.30);
        }
      }
    }
    .menu-item {
      margin-left: 20px;
    }
  }
  .menu-item, .menu-group-title {
    line-height: 24px;
    list-style: none;
    ::v-deep em {
      font-style: normal;
      color: #0068FE;
    }
  }
  .menu-item {
    display: block;
    font-size: 16px;
    margin: 4px 0 4px 0;
    padding: 8px 20px;
    cursor: pointer;
    border-radius: 6px;
    color: rgba(0, 0, 0, 0.90);
    &:hover {
      background-color: #F7F9FD;
    }
    &.is-actived {
      color: #0068FE;
      background-color: rgba(0, 117, 255, 0.10);
      border-radius: 6px;
    }
    &.more-level {
      font-size: 14px;
      padding: 5px 20px;
      line-height: 22px;
    }
  }
  .menu-group-title {
    display: block;
    font-size: 16px;
    margin: 4px 0 4px 0;
    padding: 8px 20px;
    color: rgba(0, 0, 0);
    font-weight: 500;
    &.more-level {
      font-size: 14px;
      padding: 5px 20px;
      line-height: 22px;
    }
  }
}
.external-link-item {
  display: block;
  font-size: 14px;
  color: #303133;
  /* padding: 0 30px; */
  cursor: pointer;
  transition: border-color .3s,background-color .3s,color .3s;
  box-sizing: border-box;
  height: 44px;
  line-height: 44px;
  position: relative;
  -webkit-box-sizing: border-box;
  white-space: nowrap;
  list-style: none;
  &:hover {
    outline: 0;
    background-color: #ecf5ff;
  }
}
</style>
